import PortalCategoria from './PortalCategoria'
export default PortalCategoria
